import React from 'react';
export function AnnouncementBanner() {
  return <>
      <div style={{
      color: '#fff',
      padding: '20px 0',
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '64px'
    }} className="bg-[#4A3F36]" data-id="element-1">
        <div style={{
        whiteSpace: 'nowrap',
        display: 'inline-block',
        animation: 'deslizar 20s linear infinite',
        fontSize: '22px',
        fontStyle: 'italic',
        fontWeight: 'bold'
      }} data-id="element-2">
          🔥 Nuevo precio:{' '}
          <span style={{
          textDecoration: 'line-through',
          opacity: 0.8
        }} data-id="element-3">
            $60.999
          </span>{' '}
          <span style={{
          color: '#FFD700'
        }} data-id="element-4">
            $14.999
          </span>{' '}
          · 🎉 75% OFF · 💳 3 cuotas sin interés con Mercado Pago
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 🔥 Nuevo precio:{' '}
          <span style={{
          textDecoration: 'line-through',
          opacity: 0.8
        }} data-id="element-5">
            $60.999
          </span>{' '}
          <span style={{
          color: '#FFD700'
        }} data-id="element-6">
            $14.999
          </span>{' '}
          · 🎉 75% OFF · 💳 3 cuotas sin interés con Mercado Pago
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 🔥 Nuevo precio:{' '}
          <span style={{
          textDecoration: 'line-through',
          opacity: 0.8
        }} data-id="element-7">
            $60.999
          </span>{' '}
          <span style={{
          color: '#FFD700'
        }} data-id="element-8">
            $14.999
          </span>{' '}
          · 🎉 75% OFF · 💳 3 cuotas sin interés con Mercado Pago
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
      </div>
      <style data-id="element-9">
        {`
          @keyframes deslizar {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-33.33%); }
          }
        `}
      </style>
    </>;
}